import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_2 = { class: "mb-6 flex items-center gap-3" }
const _hoisted_3 = { class: "p-2 bg-[#22282F]/10 rounded-lg" }
const _hoisted_4 = { class: "bg-white rounded-xl border border-gray-200 p-6 mb-6" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_6 = { class: "mt-5" }
const _hoisted_7 = { class: "flex flex-wrap gap-4" }
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = { class: "text-sm text-gray-700" }
const _hoisted_10 = { class: "mt-5 flex flex-wrap gap-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "mt-5 flex flex-wrap gap-3 items-center" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_15 = { class: "bg-white rounded-xl border border-gray-200 overflow-hidden" }
const _hoisted_16 = { class: "overflow-x-auto" }
const _hoisted_17 = { class: "min-w-full text-sm" }
const _hoisted_18 = { class: "divide-y divide-gray-100" }
const _hoisted_19 = { class: "px-5 py-3 font-mono text-gray-800" }
const _hoisted_20 = { class: "px-5 py-3 text-gray-600" }
const _hoisted_21 = { class: "px-5 py-3 text-gray-600" }
const _hoisted_22 = { class: "px-5 py-3 text-gray-600" }
const _hoisted_23 = { key: 0 }

import { ref, computed, onMounted } from 'vue'
import { ScrollText, Download } from 'lucide-vue-next'
import AdminLayout from '@/layouts/AdminLayout.vue'
import { apiFetch, API_BASE_URL } from '@/utils/apiFetch'
import { useToast } from '@/utils/toast'


export default /*@__PURE__*/_defineComponent({
  __name: 'LogsView',
  setup(__props) {

const toast = useToast()

const bases = ref([
  { base: 'application', checked: true },
  { base: 'errors', checked: true },
  { base: 'validations', checked: true },
])
const start = ref('')
const end = ref('')
const busy = ref(false)
const inventory = ref<any[]>([])

const presets = [
  { label: 'Dernière heure', hours: 1 },
  { label: '4 dernières heures', hours: 4 },
  { label: '24 dernières heures', hours: 24 },
  { label: '7 derniers jours', hours: 24 * 7 },
]

const canDownload = computed(
  () => (start.value || end.value) && bases.value.some(b => b.checked)
)

// datetime-local attend "YYYY-MM-DDTHH:mm:ss" en heure locale du navigateur.
function toLocalInput(d: Date) {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
}

function applyPreset(hours: number) {
  const now = new Date()
  end.value = toLocalInput(now)
  start.value = toLocalInput(new Date(now.getTime() - hours * 3600 * 1000))
}

function humanSize(n: number) {
  if (!n) return '0 o'
  const units = ['o', 'Ko', 'Mo', 'Go']
  let i = 0
  while (n >= 1024 && i < units.length - 1) { n /= 1024; i++ }
  return `${n.toFixed(i ? 1 : 0)} ${units[i]}`
}

function formatDate(s: string) {
  if (!s) return '—'
  try { return new Date(s).toLocaleString('fr-FR') } catch { return s }
}

async function loadFiles() {
  try {
    const res: any = await apiFetch('/api/admin/logs/files/')
    inventory.value = res.files || []
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Inventaire indisponible')
  }
}

async function downloadZip() {
  busy.value = true
  try {
    const params = new URLSearchParams()
    if (start.value) params.set('start', start.value)
    if (end.value) params.set('end', end.value)
    params.set('files', bases.value.filter(b => b.checked).map(b => b.base).join(','))

    const resp = await fetch(`${API_BASE_URL}/api/admin/logs/export/?${params.toString()}`, {
      method: 'GET',
      credentials: 'include',
    })
    if (!resp.ok) {
      let msg = `Erreur ${resp.status}`
      try { msg = (await resp.json()).error || msg } catch { /* ignore */ }
      throw new Error(msg)
    }
    const blob = await resp.blob()
    const cd = resp.headers.get('content-disposition') || ''
    const match = cd.match(/filename="?([^"]+)"?/)
    const filename = match ? match[1] : 'ecable-logs.zip'
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
    URL.revokeObjectURL(url)
    toast.success('Export prêt', 'Le téléchargement va démarrer.')
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Export impossible')
  } finally {
    busy.value = false
  }
}

onMounted(() => {
  applyPreset(4)
  loadFiles()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(ScrollText), { class: "w-7 h-7 text-[#22282F]" })
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-gray-900" }, "Logs applicatifs"),
            _createElementVNode("p", { class: "text-sm text-gray-500" }, "Export des journaux serveur par plage horaire (ZIP).")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "font-semibold text-gray-800 mb-1" }, "Exporter par plage horaire", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm text-gray-500 mb-4" }, " Seules les lignes comprises entre le début et la fin sont extraites, puis compressées. Le fichier n'est jamais conservé sur le serveur. ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600 mb-1" }, "Début", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "datetime-local",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((start).value = $event)),
                step: "1",
                class: "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
              }, null, 512), [
                [_vModelText, start.value]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600 mb-1" }, "Fin", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "datetime-local",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((end).value = $event)),
                step: "1",
                class: "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
              }, null, 512), [
                [_vModelText, end.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600 mb-2" }, "Fichiers à inclure", -1)),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bases.value, (f) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: f.base,
                  class: "flex items-center gap-2 cursor-pointer"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((f.checked) = $event),
                    class: "w-4 h-4"
                  }, null, 8, _hoisted_8), [
                    [_vModelCheckbox, f.checked]
                  ]),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(f.base) + ".log", 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(presets, (p) => {
              return _createElementVNode("button", {
                key: p.hours,
                type: "button",
                onClick: ($event: any) => (applyPreset(p.hours)),
                class: "px-3 py-1.5 rounded-lg text-sm border bg-white text-gray-500 border-gray-300 hover:border-[#1d2a5e]"
              }, _toDisplayString(p.label), 9, _hoisted_11)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: downloadZip,
              disabled: busy.value || !canDownload.value,
              class: "px-4 py-2 bg-[#1d2a5e] text-white rounded-lg text-sm hover:opacity-90 disabled:opacity-50 flex items-center gap-2"
            }, [
              _createVNode(_unref(Download), { class: "w-4 h-4" }),
              _cache[6] || (_cache[6] = _createTextVNode(" Télécharger le ZIP "))
            ], 8, _hoisted_13),
            (busy.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Génération…"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", { class: "px-5 py-4 border-b border-gray-100 flex items-center justify-between" }, [
            _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "font-semibold text-gray-800" }, "Fichiers disponibles", -1)),
            _createElementVNode("button", {
              onClick: loadFiles,
              class: "text-sm text-[#1d2a5e] hover:underline"
            }, "Actualiser")
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("table", _hoisted_17, [
              _cache[11] || (_cache[11] = _createElementVNode("thead", { class: "bg-gray-50 text-gray-500" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "px-5 py-3 text-left font-medium" }, "Fichier"),
                  _createElementVNode("th", { class: "px-5 py-3 text-left font-medium" }, "Rotations"),
                  _createElementVNode("th", { class: "px-5 py-3 text-left font-medium" }, "Taille"),
                  _createElementVNode("th", { class: "px-5 py-3 text-left font-medium" }, "Dernière écriture")
                ])
              ], -1)),
              _createElementVNode("tbody", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inventory.value, (f) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: f.base
                  }, [
                    _createElementVNode("td", _hoisted_19, _toDisplayString(f.base) + ".log", 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(f.rotations), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(humanSize(f.size_bytes)), 1),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(formatDate(f.last_modified)), 1)
                  ]))
                }), 128)),
                (!inventory.value.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_23, _cache[10] || (_cache[10] = [
                      _createElementVNode("td", {
                        colspan: "4",
                        class: "px-5 py-6 text-center text-gray-400"
                      }, "Aucun fichier.", -1)
                    ])))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})